import { Livewire, Alpine } from '../../../vendor/livewire/livewire/dist/livewire.esm'
import { install } from './components'
import mask from '@alpinejs/mask'
import focus from '@alpinejs/focus'

Alpine.plugin(focus)
Alpine.plugin(mask)

install(Alpine)

Livewire.start()
